import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import '../styles/style.css';
import '../styles/responsive.css';
import { initCiciEyes } from '../utils/custom';

function AuthLayout({ children }) {
  useEffect(() => {
    initCiciEyes();
  }, []);

  return (
    <div className="app-layout auth-pages">
      <nav>
        <div className="cici-container">
          {/* <div className="cici">
            <div className="orb">
              <div className="eye left"></div>
              <div className="eye right"></div>
            </div>
          </div> */}
          <span>Veetrix</span>
        </div>
      </nav>

      <main>
        <Outlet />
      </main>

      <div className="spacer"></div>
    </div>
  );  
}

export default AuthLayout;